@if (editMode$()) {
  <div class="content" animate.enter="fade-in" animate.leave="fade-out">
    <ng-container [ngTemplateOutlet]="edit"></ng-container>
  </div>
} @else {
  <div class="content" animate.enter="fade-in" animate.leave="fade-out">
    <ng-container [ngTemplateOutlet]="view"></ng-container>
  </div>
}

<ng-template #view>
  @let value = value$();
  <div *ngIf="value" class="p-2">
      @let cover = value.cover;
      @let description = value.description;
      @if (cover?.src) {
        <div class="position-relative mb-3 rounded-3 overflow-hidden shadow-sm">
          <img
            [src]="cover!.src | serverAuthUrl | safeUrl"
            alt="thumbnail"
            class="thumbnail"
          />
          <!-- @let name = value.name;
          @if (name) {
            <div class="position-absolute bottom-0 start-0 end-0 p-3 bg-gradient-dark">
              <h6 class="text-white mb-0 fw-bold">{{ name | translate}}</h6>
            </div>
          } -->
        </div>
      }
  
      <div class="d-flex flex-column gap-3">
        @if (description) {
          <div class="card shadow-sm">
            <div class="card-body py-3 px-2">
              <div class="d-flex align-items-center mb-1">
                <svg cIcon name="cilDescription" width="18" class="me-2 lex-shrink-0 "></svg>
                <span [translate]="'media.description'" class="fw-bold small flex-fill"></span>
              </div>
              <div class="w-100"
                class="small"
                style="line-height: 1.6;"
                [innerHTML]="description | translate"
              ></div>
            </div>
          </div>
        }
      </div>
      <!-- 
      <div class="mt-4 d-grid gap-2">
        <button cButton color="secondary" block (click)="onCancel()">
          {{ 'actions.close' | translate }}
        </button>
      </div> 
      -->
      <ng-container *ngIf="controlsTemplate() as template">
        <ng-container *ngTemplateOutlet="template; context: { detail: this, entity: media$(), editMode: false }"></ng-container>
      </ng-container>
  </div>
</ng-template>

<ng-template #edit>
<form *ngIf="form() as form" [formGroup]="form" cForm class="p-2" novalidate>
    @if (form.controls['cover']; as ctrl) {
      <div [cFormFloating]="true" class="mb-3">
        @let cover = form.get('cover')?.value;
        @let isDefaultMedia = mediaId$()=='0';
        <div *ngIf="cover" class="media-preview text-center"
            [class.dragging]="isDragging" (drop)="onDrop($event)" (dragover)="onDragOver($event)"
            (dragleave)="isDragging = false" (click)="fileInput.click()">
            <img [src]="cover.src | serverAuthUrl | safeUrl" alt="Image" class="thumbnail" />
            @if (isDefaultMedia) {
              <span [translate]="'media.upload.dropOrClickToUpload'"></span>
            } 
            @else {
              <button cButton type="button" size="sm" color="danger" (click)="onMediaRemove($event)">
                <svg cIcon name="cilX" aria-label="Close" ></svg>
              </button>
            }
            <div *ngIf="file" class="file-size text-muted">{{ file.size | filesize }}</div>
        </div>
        <!-- @if (uploading()) {
            <progress 
                [value]="uploadProgress$()" 
                color="primary" 
                class="mt-3" 
                height="8"
                animated
                animate.leave="leaving">
            </progress>
        } -->
        <c-input-group [cFormFloating]="true" class="mt-2 path">
            <input cFormControl 
                    id="media" 
                    type="text" 
                    [value]="!isDefaultMedia ? cover?.src : null"
                    disabled
                    placeholder="No media selected"
                    aria-label="media path"
                    [valid]="undefined"
                    [class.is-valid]="false"/>
            @if (uploading()) {
                <div class="upload-progress" [style.width.%]="uploadProgress$()" animate.leave="leaving"></div>
            }
            <span cInputGroupText class="upload" (click)="fileInput.click()">
                <svg cIcon name="cilCloudUpload"></svg>
            </span>
            <label cLabel [translate]="'media.cover'"></label>
            @if (isDefaultMedia) {
              <!-- <c-form-feedback [valid]="!isDefaultMedia" [translate]="'media.validation.mediaRequired'"></c-form-feedback> -->
            }
        </c-input-group>

        <!-- <div *ngIf="uploadError" class="alert alert-danger mt-3 py-2">
            Upload failed. Please try again.
        </div> -->

        <input #fileInput type="file" class="d-none" (change)="onFileSelected($event)" />
      </div>
    }
    @if (form.controls['name']; as ctrl) {
      <div [cFormFloating]="true" class="mb-3">
        <input cFormControl formControlName="name" id="name" [valid]="isValid(ctrl)" required/>
        <label cLabel for="name" [translate]="'media.name'"></label>
        @if (ctrl.invalid) {
          <c-form-feedback [valid]="!ctrl.invalid">
            @if (ctrl.hasError('required')) {
              <span [translate]="'media.validation.nameRequired'"></span>
            } @else if (ctrl.hasError('minlength')) {
              <span [translate]="'media.validation.nameMinLength'" [translateParams]="{ minLength: 3 }"></span>
            } 
          </c-form-feedback>
        }
      </div>
    }

    <div [cFormFloating]="true" class="mb-3">
      <textarea cFormControl formControlName="description" id="description" rows="5"></textarea>
      <label cLabel for="description" [translate]="'media.description'"></label>
    </div>

    <!-- <div class="mb-3">
        <label cFormLabel>Tags (comma separated)</label>
        <input cFormControl type="text" formControlName="tags" />
    </div> -->

    <!-- 
    <div class="d-grid gap-2 mt-4">
      @let formState = formState$();
      <button
          cButton
          color="primary"
          [disabled]="!(formState.valid && formState.dirty)"
          (click)="onSave()"
      >
      {{'actions.save' | translate}}
      </button>
      <button
          cButton
          color="secondary"
          [disabled]="false && !formState.dirty"
          (click)="onCancel()"
      >
      {{'actions.cancel' | translate}}
      </button>
      <button
        *ngIf="mediaId$()"
        cButton
        color="danger"
        (click)="onDelete()"
      >
        {{'actions.delete' | translate}}
      </button> 
    </div>
    -->
    <ng-container *ngIf="controlsTemplate() as template">
      <ng-container *ngTemplateOutlet="template; context: { detail: this, entity: media$(), editMode: true }"></ng-container>
    </ng-container>
</form>
</ng-template>
